import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const ProspectsPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default ProspectsPageLayout;